import {
  defineBlock,
  BlockWrapper,
  smartProps,
  useEditor,
} from "@smartfire/js-block-engine";
import style from "./block.module.scss";
import { EditableText } from "@smartfire/components";
import useMediaQuery from "@mui/material/useMediaQuery";

function Block({ posts }) {
  const options = { year: "numeric", month: "long", day: "numeric" };
  const { isEditing } = useEditor();
  const isMobile = useMediaQuery("(max-width: " + style.mobileBreakpoint + ")");

  function timeAgo(dateString) {
    const units = [
      { name: "an", divisor: 365 * 24 * 60 * 60 },
      { name: "mois", divisor: 30 * 24 * 60 * 60 },
      { name: "jour", divisor: 24 * 60 * 60 },
      { name: "heure", divisor: 60 * 60 },
      { name: "minute", divisor: 60 },
      { name: "seconde", divisor: 1 },
    ];
    const date = new Date(dateString);
    const now = new Date();
    let diffInSeconds = Math.floor((now - date) / 1000);
    for (const unit of units) {
      const time = Math.floor(diffInSeconds / unit.divisor);
      if (time >= 1) {
        return `Publié il y a ${time} ${unit.name}${
          time > 1 && unit.name !== "mois" ? "s" : ""
        }`;
      }
    }
    return "Publié à l'instant";
  }

  return (
    <BlockWrapper.Div className={style.block}>
      {!isMobile && <div className={style.header} />}
      <div className={style.content}>
        <div>
          <EditableText
            tagName={"p"}
            smartProp={"title"}
            placeholder={"Insérer un titre..."}
            className={style.title}
          />
          <div className={style.container}>
            {isEditing ? (
              <p className={style.textEditor}>Le contenu s'affichera ici</p>
            ) : (
              <>
                <div>
                  {posts && posts.length > 0 && (
                    <a href={posts[0].post_url}>
                      <img src={posts[0].thumbnail_url} alt="" />
                      <p className={style.firstPublishAgo}>
                        {timeAgo(new Date(posts[0].post_date))}
                      </p>
                      <h3 className={style.firstTitle}>
                        {posts[0].post_title}
                      </h3>
                      <p className={style.firstExcerpt}>
                        {posts[0].post_excerpt}
                      </p>
                      <button className={style.firstLink}>
                        Lire l'article
                      </button>
                      <div className={style.firstCategories}>
                        {posts[0].category_names.map((category) => (
                          <p>{category}</p>
                        ))}
                      </div>
                      {posts[0].tag_data.length > 0 && (
                        <div className={style.tags}>
                          {posts[0].tag_data.map((tag) => (
                            <img
                              key={tag.slug}
                              src={tag.image_url}
                              alt={tag.name}
                            />
                          ))}
                        </div>
                      )}
                    </a>
                  )}
                </div>
                <div className={style.rightPost}>
                  {posts &&
                    posts.length > 0 &&
                    posts.slice(1, posts.length - 1).map((post) => (
                      <a href={post.post_url}>
                        <div className={style.littlePost}>
                          <div>
                            <img src={post.thumbnail_url} alt="" />
                          </div>
                          <div>
                            <p className={style.postDate}>
                              {new Date(post.post_date).toLocaleDateString(
                                "fr-FR",
                                options
                              )}
                            </p>
                            <p className={style.postTitle}>{post.post_title}</p>
                          </div>
                        </div>
                      </a>
                    ))}
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </BlockWrapper.Div>
  );
}

export default defineBlock({
  Block,
  smartProps: {
    posts: smartProps.array.withDefault([]).contentServerSide,
    title: smartProps.string.withDefault("Découvrez nos actualités"),
  },
  setup: {
    title: "Last actu",
  },
});
